/* Price on request (WORK-264). Markup: snippets/quote-request.liquid. A 0-price row's
   «Προσφορά» button opens one shared <dialog> with a Shopify contact form; the clicked row's
   code goes into the heading and the hidden fields the email carries. The form posts and the
   store redirects back to #vt-quote-form, so on that hash the popup reopens to show the
   success or error message. Rows added by «load more» work too: the open handler is delegated
   on the document. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-quote-dialog]');
  if (!dlg) return;
  var codeLabel = dlg.querySelector('[data-quote-code-label]');
  var codeText = dlg.querySelector('[data-quote-code-text]');
  var lastTrigger = null;

  function field(name) { return dlg.querySelector('[data-quote-field="' + name + '"]'); }

  function show() {
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    document.documentElement.classList.add('vt-qr-locked');
  }

  function open(trigger) {
    var code = trigger.getAttribute('data-quote-code') || '';
    lastTrigger = trigger;
    codeText.textContent = code;
    codeLabel.hidden = !code;
    var set = { code: code, variant: trigger.getAttribute('data-quote-variant') || '', 'variant-id': trigger.getAttribute('data-quote-variant-id') || '' };
    Object.keys(set).forEach(function (k) { var f = field(k); if (f) f.value = set[k]; });
    show();
  }

  function close() {
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-quote-open]');
    if (!t) return;
    e.preventDefault();
    open(t);
  });
  // The inner box fills the dialog, so a click whose target is the <dialog> itself landed on
  // the backdrop.
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-quote-close]')) close();
  });
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('vt-qr-locked');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  });
  if (location.hash === '#vt-quote-form') show();
})();
